import React, {PureComponent} from "react"

import {FormattedMessage, FormattedCurrency} from "@irati/utils/lang"
import {Wallet} from "@irati/types"
import {Body, H4, Label} from "@irati/ui/src/Typography"
import Flex from "@irati/ui/src/Flex"
import {WalletIcon} from "./styled/WalletSpendBalance"

interface Props {
  wallet: Wallet
}

class WalletSpendBalance extends PureComponent<Props> {
  static defaultProps = {
    className: null
  }

  render() {
    const {wallet} = this.props
    const {availableBalanceInCents, currency} = wallet

    return (
      <Flex direction="column" alignItems="center">
        <Body marginBottom={3} textAlign="center">
          <FormattedMessage id="perks.walletSpendBalance.intro" />
        </Body>
        <Label display="inline-block" color="contrast">
          <FormattedMessage id="perks.walletSpendBalance.balanceLabel" />
        </Label>
        <H4 marginBottom={3}>
          <WalletIcon icon="wallet" />
          <FormattedCurrency value={availableBalanceInCents} currency={currency} />
        </H4>
      </Flex>
    )
  }
}

export default WalletSpendBalance
